import { MediaQueries } from 'custom_hooks/useWindowSize';
import styled from 'styled-components';
import { inputBorder, navBorderColor } from 'styles/theme';

export const Header = styled.div`
    font-weight: bold;
    font-size: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 0;
    margin-bottom: 1rem;
`;

export const Separator = styled.div`
    border-top: 1px solid ${navBorderColor};
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    max-width: 40rem;
`;

export const DetailGrid = styled.div`
    display: grid;
    grid-template-columns:
        minmax(170px, 175px)
        minmax(245px, 350px);

    @media ${MediaQueries.smallAndDown} {
        grid-template-columns: 1fr;
    }
`;

export const DetailCell = styled.div`
    border-bottom: 1px solid ${inputBorder};
    padding: 0.75rem 0;
`;

export const DetailName = styled(DetailCell)`
    font-weight: bold;
    display: flex;
    align-items: center;
    padding-right: 1rem;
    white-space: nowrap;
`;

export const DetailValue = styled(DetailCell)``;
